import { createReducer } from '@reduxjs/toolkit';
import {
  clearActiveProjects,
  clearSettings,
  getActiveProjectsSuccess,
  getAvailableLanguagesSuccess,
  getCustomersSuccess,
  getTemplatesByCustomerIdSuccess,
} from './settings.actions';
import { ISettingsState } from './settings.interface';

const initState: ISettingsState = {
  xtmCustomer: undefined,
  xtmTemplate: undefined,
  activeProjects: undefined,
};

export const settingsReducer = createReducer(initState, (builder) =>
  builder
    .addCase(getCustomersSuccess, (state, action) => {
      state.xtmCustomer = action.payload;
    })
    .addCase(getTemplatesByCustomerIdSuccess, (state, action) => {
      state.xtmTemplate = action.payload;
    })
    .addCase(getActiveProjectsSuccess, (state, action) => {
      state.activeProjects = action.payload;
    })
    .addCase(clearSettings, (state) => {
      state.xtmTemplate = undefined;
      state.activeProjects = undefined;
    })
    .addCase(clearActiveProjects, (state) => {
      state.activeProjects = undefined;
    })
    .addCase(getAvailableLanguagesSuccess, (state, { payload }) => {
      state.availableLanguages = payload;
    }),
);
